import { useQuery } from "@tanstack/react-query";

import { getPracticeManagementMineralFertilizerEmissionFactors } from "services";

import { PRACTICE_MANAGEMENT, PRACTICE_MANAGEMENT_MINERAL_FERTILIZER_EMISSION_FACTORS } from "consts";

export const usePracticeManagementMineralFertilizerEmissionFactors = (version?: string, country: PracticeManagement.CountryCode = "global") =>
  useQuery({
    queryKey: [PRACTICE_MANAGEMENT, PRACTICE_MANAGEMENT_MINERAL_FERTILIZER_EMISSION_FACTORS, country, version],
    queryFn: async () => {
      const factors = await getPracticeManagementMineralFertilizerEmissionFactors(version, country);
      return factors.map((factor) => ({
        ...factor,
        editingKey: factor.fertilizerId,
      }));
    },
    staleTime: 1000 * 60 * 60, // 1h
    gcTime: 1000 * 60 * 24,
  });
